// src/components/TransactionHistory.tsx
import { Box, Tab, TabIndicator, TabList, TabPanel, TabPanels, Tabs } from '@chakra-ui/react';
import { ArrowForwardIcon } from '@chakra-ui/icons';
import { IGetPaymentHistoryParams } from '@/services/payment/types';
import { useState, useCallback, useMemo } from 'react';

// Direct imports (no lazy loading)
import AdminVendorPayment from '../AdminPaymentVendor';
import CustomerVendorPayment from '../CustomerVendorPayment';

interface TransactionHistoryProps {
  isLoading?: boolean;
  isError?: boolean;
  transactionData?: { results: IGetPaymentHistoryParams[] };
}

const TransactionHistory: React.FC<TransactionHistoryProps> = () => {
  const [selectedTabIndex, setSelectedTabIndex] = useState(0);

  const handleTabChange = useCallback((index: number) => {
    setSelectedTabIndex(index);
  }, []);

  const tabs = useMemo(
    () => [
      {
        label: (
          <>
            Admin <ArrowForwardIcon mx="4px" boxSize="14px" /> Vendor Payment
          </>
        ),
        content: () => <AdminVendorPayment />,
      },
      {
        label: (
          <>
            Customer <ArrowForwardIcon mx="4px" boxSize="14px" /> Vendor Payment
          </>
        ),
        content: () => <CustomerVendorPayment />,
      },
    ],
    [],
  );

  return (
    <Tabs
      index={selectedTabIndex}
      onChange={handleTabChange}
      colorScheme="brand.primary"
      color="text.secondary"
    >
      <TabList
        gap={8}
        w={{ base: '100%', lg: '50%' }}
        borderBottom="1px solid"
        borderColor="gray.200"
      >
        {tabs.map((tab, index) => (
          <Tab
            key={index}
            width="200px"
            px={5}
            fontWeight="semibold"
            w={{ base: '100%', lg: '50%' }}
            _selected={{ color: 'brand.primary.DEFAULT' }}
            _hover={{ color: 'brand.primary.DEFAULT' }}
            pb={3}
          >
            {tab.label}
          </Tab>
        ))}
      </TabList>

      <TabIndicator mt="-1.5px" height="2px" bg="brand.primary.DEFAULT" borderRadius="1px" />

      <TabPanels minH="600px">
        {tabs.map((tab, index) => (
          <TabPanel key={index} px={0} py={4}>
            {/* Only render the active tab */}
            {selectedTabIndex === index && <Box fontFamily="primary">{tab.content()}</Box>}
          </TabPanel>
        ))}
      </TabPanels>
    </Tabs>
  );
};

export default TransactionHistory;
